// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
import "../../../style/sassStyle";

import { Checkbox, FormControlLabel } from "@material-ui/core";
import { DummyEvent, QuestionnaireInputProps } from "./QuestionnaireTypes";
import React, { useCallback } from "react";

import QuestionnaireStandardFormControl from "./QuestionnaireStandardFormControl";

/**
 * Renders a Checkbox in a questionaire.
 * You should not need to use this outside of the Questionnaire component.
 */
const QuestionnaireInputCheckbox = (props: QuestionnaireInputProps) => {
  const { question, onChange } = props;

  if (question.type !== "checkbox") {
    throw Error(
      `Invalid question type ${question.type} for QuestionnaireInputCheckbox.`
    );
  }

  const onChangeWrapper = useCallback(
    (
      event: React.ChangeEvent<{ name?: string; checked: boolean }>,
      child: React.ReactNode
    ) => {
      const value = event.target.checked ? "true" : "false";

      const dummyEvent: DummyEvent = {
        currentTarget: {
          name: question.name,
          value,
        },
      };
      onChange(dummyEvent);
    },
    [onChange, question.name]
  );

  const fieldId = question.name + "-field";

  return (
    <QuestionnaireStandardFormControl
      error={question.error}
      fieldId={fieldId}
      mandatory={question.mandatory}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={question.value === "true"}
            onChange={onChangeWrapper}
            id={fieldId}
            inputProps={{ "aria-label": "primary checkbox" }}
            color="primary"
          />
        }
        label={question.label}
      />
    </QuestionnaireStandardFormControl>
  );
};

export default QuestionnaireInputCheckbox;
